var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.dataList)?_c('p',{staticStyle:{"font-size":"14px","font-weight":"500","text-align":"center"}},[_vm._v(" "+_vm._s(_vm.data.dataList.length > 0 ? _vm.convertTime(_vm.data.dataList[0].data) : "")+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }